import React from "react";
import Chart from "react-apexcharts";

const DashboardChart = () => {
  return (
    <>
      <div className="text-center mt-3">
        <div
          className="row justify-content-center"
          style={{ overflowY: "scroll" }}
        >
          <div className="col-md-6 border">
            <Chart
              type="bar"
              width={550}
              height={500}
              series={[
                {
                  name: `Internships`,
                  data: [44, 55],
                  colors: "#539165",
                },
                {
                  name: `Jobs`,
                  data: [44, 55],
                  colors: "#539165",
                },
                {
                  name: `Events`,
                  data: [44, 55],
                  colors: "#539165",
                },
                {
                  name: `Blogs`,
                  data: [44, 55],
                  colors: "#539165",
                },
                {
                  name: `Talks`,
                  data: [44, 55],
                  colors: "#539165",
                },
                {
                  name: `Podcasts`,
                  data: [44, 55],
                  colors: "#539165",
                },
                {
                  name: `Polls`,
                  data: [44, 55],
                  colors: "#539165",
                },
                {
                  name: `News`,
                  data: [44, 55],
                  colors: "#539165",
                },
              ]}
              options={{
                title: { text: "Total data" },
                labels: ["Industry", "Yuvasarathi"],
                chart: {
                  stacked: true,
                },
                xaxis: {
                  title: { text: "Total data" },
                },
              }}
              className="d-flex justify-content-center"
            ></Chart>
          </div>

          <div className="col-md-6 border">
            <Chart
              type="line"
              width={550}
              height={500}
              series={[
                {
                  name: "Internships",
                  data: [44, 55, 57, 56, 57, 56],
                },
                {
                  name: "Jobs",
                  data: [44, 55, 57, 56, 57, 56],
                },
                {
                  name: "Events ",
                  data: [44, 55, 57, 56, 57, 56],
                },
                {
                  name: "Blogs",
                  data: [44, 55, 57, 56, 57, 56],
                },
                {
                  name: "Podcasts",
                  data: [44, 55, 57, 56, 57, 56],
                },
                {
                  name: "Polls",
                  data: [44, 55, 57, 56, 57, 56],
                },
                {
                  name: "News",
                  data: [44, 55, 57, 56, 57, 56],
                },
                {
                  name: "Talks",
                  data: [44, 55, 57, 56, 57, 56],
                },
              ]}
              options={{
                title: { text: "Yearly data" },
                xaxis: {
                  title: { text: "Industry Data" },
                  categories: [
                    "Jan",
                    "Feb",
                    "Mar",
                    "Apr",
                    "May",
                    "June",
                    "July",
                    "Aug",
                    "Sept",
                    "Oct",
                    "Nov",
                    "Dec",
                  ],
                },
                labels: [
                  "Nashik Road",
                  "Nashik West",
                  "Nashik East",
                  "Panchavati",
                  "Cidco",
                  "Satpur",
                ],
              }}
            ></Chart>
          </div>
        </div>

        <div className="row justify-content-center">
          <div className="col-md-6 mt-4">
            <Chart
              type="donut"
              width={500}
              height={400}
              series={[350, 300, 300, 200, 100, 600, 605]}
              options={{
                labels: ["jan", "feb", "mar", "apr", "may", "june", "july"],

                title: {
                  text: "Month Wise Internship Applications ",
                },
              }}
            ></Chart>
          </div>

          <div className="col-md-6 mt-4">
            <Chart
              type="donut"
              width={500}
              height={400}
              series={[350, 300, 300, 200, 100, 600, 605]}
              options={{
                labels: ["jan", "feb", "mar", "apr", "may", "june", "july"],

                title: {
                  text: "Month Wise Job Applications ",
                },
              }}
            ></Chart>
          </div>
        </div>
      </div>
    </>
  );
};

export default DashboardChart;
